import role from "./roleSlice";
import { configureStore } from "@reduxjs/toolkit";
import auth from "./authenticationSlice";
import notification from './notification_slice';

export const store = configureStore({
  reducer: {
    auth,
    role,
    notification
  },
});

export type RootState = ReturnType<typeof store.getState>;
